import { render, staticRenderFns } from "./housingSummary.vue?vue&type=template&id=8728ac0c&scoped=true"
import script from "./housingSummary.vue?vue&type=script&lang=js"
export * from "./housingSummary.vue?vue&type=script&lang=js"
import style0 from "./housingSummary.vue?vue&type=style&index=0&id=8728ac0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8728ac0c",
  null
  
)

export default component.exports